import routeDepartment from "./routes/department/department.route";
import routeEmployees from "./routes/employees/employees.route";
import routePosition from "./routes/position/position.route";
import routeRole from "./routes/role/role.route";

const routes = [
  ...routeEmployees,
  ...routeRole,
  ...routeDepartment,
  ...routePosition
];

export default routes;
